import { useEffect, useState } from "react";
import { History, User, Clock } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Activity() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/activity").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  if (user && user.role !== "admin") {
    return (
      <div className="ml-64 p-8 min-h-screen flex items-center justify-center">
        <div className="nb-card p-10 text-center max-w-md" data-testid="activity-access-denied">
          <h2 className="font-heading font-black text-2xl mb-2">Accès refusé</h2>
          <p className="text-slate-500 font-medium">Seul l'administrateur peut consulter le journal.</p>
        </div>
      </div>
    );
  }

  const fmt = (ts) => {
    try {
      return new Date(ts).toLocaleString("fr-FR");
    } catch {
      return ts;
    }
  };

  return (
    <div className="ml-64 p-8 min-h-screen">
      <div className="mb-8 mc-slide-up">
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight">Journal d'activité</h1>
        <p className="text-slate-500 font-medium mt-1">Qui a modifié quoi — visible par l'administrateur</p>
      </div>

      {items.length === 0 ? (
        <div className="nb-card p-10 text-center" data-testid="activity-empty">
          <History size={40} strokeWidth={2.5} className="mx-auto text-slate-300 mb-3" />
          <p className="font-heading font-black text-xl">Aucune activité enregistrée</p>
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((it, i) => (
            <div key={it.id || i} data-testid={`activity-row-${i}`} className="nb-card p-4 flex items-center justify-between gap-4 mc-pop">
              <div className="flex items-center gap-3 min-w-0">
                <div className="w-10 h-10 rounded-xl border-2 border-slate-900 flex items-center justify-center bg-[#A5B4FC] shrink-0">
                  <History size={18} strokeWidth={2.5} />
                </div>
                <div className="min-w-0">
                  <p className="font-heading font-bold truncate">
                    {it.action}
                    {it.detail ? <span className="font-medium text-slate-500"> — {it.detail}</span> : null}
                  </p>
                  <p className="text-xs text-slate-500 font-medium flex items-center gap-1">
                    <User size={12} strokeWidth={2.5} /> {it.user_email}
                  </p>
                </div>
              </div>
              <span className="text-xs font-bold text-slate-500 flex items-center gap-1 shrink-0 font-mono-plate">
                <Clock size={12} strokeWidth={2.5} /> {fmt(it.ts)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
